import Box from "@mui/material/Box";
import { Theme } from "../../data/style/Theme";
import { AllCenteredColumn, MainText } from "../../data/style/Style";

const GenWorkoutError = () => {
  return (
    <AllCenteredColumn height={"100%"}>
      <Box width={"95%"} textAlign={"center"}>
        <MainText sx={{ color: Theme.palette.down + " !important" }}>
          Opps! An unexpected error occured while trying to generate the
          workout. Please try again.
        </MainText>
      </Box>
    </AllCenteredColumn>
  );
};

export default GenWorkoutError;
